export const apiHost = {
  //  baseURL: "https://prod-ecs-api.daqi.in/api/", 
   // baseURL: "https://api.daqi.in/api/",
   // baseURL: "http://10.36.20.188:3005/api/",
   // baseURL: "http://localhost:3005/api/",
   // baseURL: "https://dev-api.daqi.in/api/",
   baseURL: "https://dev-ecs-api.daqi.in/api/",
      baseCmsURL: "https://prod-ecs-cms.daqi.in/",
      authenticateAccessKey: "d8f2b3a4-5d1e-47b0-b3c1-123abc456def",
};